
  import { ACCOUNT_TYPES } from '@/constants/currents';
  import { COOKIE_CURRENT_ACCOUNT_SEARCH, COOKIE_CURRENT_ACCOUNT_TYPE } from '@/constants/cookies';

  export default {
    middleware: ['pages/products/banking/current-accounts/index', 'meta-tags', 'breadcrumbs'],
    meta: {
      breadcrumbs: [['i18n/home', '/'], ['i18n/banking', '/money/', 'mobile'], 'i18n/currents'],
      metaTagOptions: { image: 'currents' },
      product: 'currents'
    },
    data () {
      return { accountTypes: ACCOUNT_TYPES };
    },
    created () {
      this.$store.dispatch('matomo/trackIndexPageViewed', { name: 'Current Accounts index page viewed' });
    },
    methods: {
      click (product) {
        this.$cookies.remove(COOKIE_CURRENT_ACCOUNT_SEARCH);
        this.$cookies.set(COOKIE_CURRENT_ACCOUNT_TYPE, product);
        this.$router.push(this.localePath('/compare-current-accounts/your-results/'));
      }
    }
  };
